import { render, staticRenderFns } from "./ModalATS.vue?vue&type=template&id=cfa4c22a&"
import script from "./ModalATS.vue?vue&type=script&lang=js&"
export * from "./ModalATS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports